<h1>{{ 'buy-ticket.generate-ticket' | translate:{ gameName: currentGameGroup.name } }}</h1>

<ra-coupon-picker #scrollTo [hidden]="!mobilePickNumbers && isMobile"></ra-coupon-picker>
<ra-purchase-print (scrollIntoView)="scrollIntoView()"></ra-purchase-print>
